import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";
import { BotaoAcao, Cartao, Pagina } from "./ui/Painel";

const RegisterDistrital = () => {
  const navigate = useNavigate();
  const [nome, setNome] = useState("");
  const [limiteParticipantes, setLimiteParticipantes] = useState("");
  const [mensagem, setMensagem] = useState(null);
  const [erros, setErros] = useState({});
  const [enviando, setEnviando] = useState(false);

  const validarCampos = () => {
    const novosErros = {};
    if (!nome.trim()) novosErros.nome = "Nome da distrital é obrigatório.";
    if (!limiteParticipantes) novosErros.limite = "Limite de participantes é obrigatório.";
    else if (parseInt(limiteParticipantes, 10) <= 0) novosErros.limite = "O limite deve ser maior que zero.";

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem(null);
    if (!validarCampos()) return;

    setEnviando(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/distrital/cadastrar`, {
        nome,
        limite_participantes: limiteParticipantes,
      });
      setMensagem({ tipo: "success", texto: `Distrital "${nome.trim()}" cadastrada com sucesso!` });
      setNome("");
      setLimiteParticipantes("");
      setErros({});
    } catch (error) {
      console.error("Erro ao cadastrar distrital:", error);
      setMensagem({ tipo: "error", texto: "Erro ao cadastrar distrital. Tente novamente." });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Pagina
      eyebrow="Cadastros"
      titulo="Cadastrar distrital"
      descricao="O limite define quantos convites a distrital ainda pode enviar."
      largura={720}
      acoes={<BotaoAcao onClick={() => navigate("/listagem-distritais")}>Ver distritais</BotaoAcao>}
    >
      <Cartao titulo="Nova distrital">
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {mensagem && <Alert severity={mensagem.tipo}>{mensagem.texto}</Alert>}

          <TextField
            label="Nome da distrital"
            size="small"
            fullWidth
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            error={!!erros.nome}
            helperText={erros.nome}
          />
          <TextField
            label="Limite de participantes"
            type="number"
            size="small"
            fullWidth
            value={limiteParticipantes}
            onChange={(e) => setLimiteParticipantes(e.target.value)}
            error={!!erros.limite}
            helperText={erros.limite}
            slotProps={{ htmlInput: { min: 1 } }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" type="submit" disabled={enviando} sx={{ minWidth: 140 }}>
              {enviando ? <CircularProgress size={20} color="inherit" /> : "Cadastrar"}
            </Button>
          </Box>
        </Box>
      </Cartao>
    </Pagina>
  );
};

export default RegisterDistrital;
